<template>
  <div
    class="modal fade ag-modal"
    id="addCategory"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header p-0 pt-2 ag-card_navigation">
          <h4>
            <span class="modal-title-server">{{$t("endpointType")}} </span> :
            <span class="modal-title-global">{{$t("addNewCategory")}}</span>
          </h4>
        </div>
        <div class="modal-body">
          <div class="model-content-form">
            <div class="form-group">
              <label for="exampleInputPassword1">{{$t("nameOfCategory")}}</label>
              <input
                type="text"
                class="form-control"
                id="exampleInputPassword1"
                style="width: 100%"
              />
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="exampleCheck1"
              />
              <label class="form-check-label" for="exampleCheck1"
                >{{$t("multipleSelectForNodes")}}</label
              >
            </div>
          </div>
        </div>
        <div class="modal-footer ag-modal-footer">
          <button
            type="button"
            class="border-0 ag-button_radius pr-4 pl-4 ag-button-footer-white"
            data-dismiss="modal"
          >
            {{$t("cancel")}}
          </button>

          <button
            type="button"
            class="border-0 ag-button_radius pr-4 pl-4 ag-button-footer"
            data-dismiss="modal"
          >
            {{$t("save")}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade ag-modal"
    id="addNode"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header p-0 pt-2 ag-card_navigation">
          <h4>
            <span class="modal-title-server">{{$t("windowsServer")}} </span> :
            <span class="modal-title-global">{{$t("addNewNode")}}</span>
          </h4>
        </div>
        <div class="modal-body">
          <div class="model-content-form">
            <div class="form-group">
              <label for="exampleInputPassword1">{{$t("nameOfNode")}}</label>
              <input
                type="text"
                class="form-control"
                id="exampleInputPassword1"
                style="width: 100%"
              />
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="exampleCheck1"
              />
              <label class="form-check-label" for="exampleCheck1"
                >{{$t("multipleSelectForNodes")}}</label
              >
            </div>
          </div>
        </div>
        <div class="modal-footer ag-modal-footer">
          <button
            type="button"
            class="border-0 ag-button_radius pr-4 pl-4 ag-button-footer-white"
            data-dismiss="modal"
          >
            {{$t("cancel")}}
          </button>

          <button
            type="button"
            class="border-0 ag-button_radius pr-4 pl-4 ag-button-footer"
            data-dismiss="modal"
          >
            {{$t("save")}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade ag-modal"
    id="addCategory"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header p-0 pt-2 ag-card_navigation">
          <h4>
            <span class="modal-title-server">{{$t("endpointType")}} </span> :
            <span class="modal-title-global">{{$t("addNewCategory")}}</span>
          </h4>
        </div>
        <div class="modal-body">
          <div class="model-content-form">
            <div class="form-group">
              <label for="exampleInputPassword1">{{$t("nameOfCategory")}}</label>
              <input
                type="text"
                class="form-control"
                id="exampleInputPassword1"
                style="width: 100%"
              />
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="exampleCheck1"
              />
              <label class="form-check-label" for="exampleCheck1"
                >{{$t("multipleSelectForNodes")}}</label
              >
            </div>
          </div>
        </div>
        <div class="modal-footer ag-modal-footer">
          <button
            type="button"
            class="border-0 ag-button_radius pr-4 pl-4 ag-button-footer-white"
            data-dismiss="modal"
          >
            {{$t("cancel")}}
          </button>

          <button
            type="button"
            class="border-0 ag-button_radius pr-4 pl-4 ag-button-footer"
            data-dismiss="modal"
          >
            {{$t("save")}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="ag-electives">
    <div class="header mb-5">
      <h6 class="shared-tab-title shared-header">
        <div class="shared-tab-content" @click="changeSharedTab('electives')">
          <img
            src="/assets/image/group.svg"
            class="mb-2"
            alt=""
            width="18"
            height="20"
          />
          <span
            :class="
              sharedTab === 'electives'
                ? 'modal-title-ag modal-title-ag-underline'
                : 'modal-title-ag'
            "
            >{{$t("electivesTopology")}}
          </span>
        </div>
        <div
          class="shared-tab-content"
          @click="changeSharedTab('buildingblocks')"
        >
          <img
            src="/assets/image/group.svg"
            class="mb-2"
            alt=""
            width="18"
            height="20"
          />
          <span
            :class="
              sharedTab === 'buildingblocks'
                ? 'modal-title-ag modal-title-ag-underline'
                : 'modal-title-ag'
            "
            >{{$t("buildingBlocksTopology")}}</span
          >
        </div>
      </h6>
    </div>
    <div class="navigation">
      <div class="tab-content" style="width: 50%">
        <div
          id="electives"
          class="fade in active show"
          v-if="sharedTab === 'electives'"
        >
          <div class="body">
            <div class="endpoint-types">
              <ul class="ag-tree-list">
                <li class="list-header">
                  <a
                    class="item"
                    data-toggle="collapse"
                    data-target="#endpoints"
                    href="#"
                  >
                    {{$t("endpointTypes")}}
                  </a>

                  <span
                    class="ag-tree-category"
                    data-toggle="modal"
                    data-target="#addCategory"
                  >
                    + {{$t("addCategory")}}
                  </span>
                </li>
                <div id="endpoints" class="collapse show">
                  <div class="add-node-header">
                    <h4>{{$t("windowsServer")}}</h4>
                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      + {{$t("addNode")}}
                    </span>
                  </div>

                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>{{$t("standardServer")}}</li>
                      <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("standardServer")}}</li>
                          <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("RDSServer")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("sqlServer")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("activeServer")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("webServer")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                  <div class="add-node-header">
                    <h4>{{$t("windowsWorkstation")}}</h4>
                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      + {{$t("addNode")}}
                    </span>
                  </div>

                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>{{$t("standardWorkstation")}}</li>
                          <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("NP-VDI")}}</li>
                            <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("IOT")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                </div>
              </ul>
            </div>
            <div class="appgroups">
              <ul class="ag-tree-list">
                <li class="list-header appgroups">
                  <a
                    class="item"
                    href="#"
                    data-toggle="collapse"
                    data-target="#appgroups"
                  >
                    {{$t("appGroup")}}
                  </a>
                  <span class="ag-tree-category"> + {{$t("addCategory")}} </span>
                </li>
                <div id="appgroups" class="collapse show">
                  <div class="add-node-header">
                    <h4>{{$t("wProductivitySoftware")}}</h4>
                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      + {{$t("addNode")}}
                    </span>
                  </div>
                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>
                        <span class="mr-4">{{$t("office")}}</span>

                        <select name="" class="form-controls">
                          <option>{{$t("office")}}</option>
                          <option>{{$t("officeLite")}}</option>
                        </select>
                      </li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("adobe")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                  <div class="add-node-header">
                    <h4>{{$t("browsers")}}</h4>
                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      + {{$t("addNode")}}
                    </span>
                  </div>

                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>Firefox</li>
                            <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>Chrome</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actios")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("otherBrowser")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                  <div class="add-node-header">
                    <h4>{{$t("databases")}}</h4>

                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      + {{$t("addNode")}}
                    </span>
                  </div>
                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>SQL</li>
                          <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                  <div class="add-node-header">
                    <h4>{{$t("webServers")}}</h4>

                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      + {{$t("addNode")}}
                    </span>
                  </div>
                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>{{$t("ISS")}}</li>
                          <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                  <div class="add-node-header">
                    <h4>{{$t("mailClients")}}</h4>

                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      +{{$t("addNode")}}
                    </span>
                  </div>
                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>{{$t("Outlook")}}</li>
                            <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("OutlookExpress")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                  <div class="add-node-header">
                    <h4>{{$t("otherAppGroups")}}</h4>

                    <span
                      class="ag-tree-node"
                      data-toggle="modal"
                      data-target="#addNode"
                    >
                      + {{$t("addNode")}}
                    </span>
                  </div>
                  <ul class="sub-tree">
                    <div class="sub-tree-list">
                      <li>{{$t("riskyApplication")}}</li>
                            <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("WMI")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("passtheHash")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                </div>
              </ul>
            </div>
            <div class="general">
              <ul class="ag-tree-list">
                <li class="list-header general">
                  <a
                    class="item"
                    href="#"
                    data-toggle="collapse"
                    data-target="#general"
                  >
                    {{$t("generalProtections")}}
                  </a>
                  <span class="ag-tree-category"> + {{$t("addCategory")}} </span>
                </li>
                <div id="general" class="collapse show">
                  <ul class="sub-tree mb-5">
                    <div class="sub-tree-list">
                      <li>{{$t("riskUtilities")}}</li>
                          <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("drivebyDownload")}}</li>
                          <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                    <div class="sub-tree-list">
                      <li>{{$t("enforcePowershellCLM")}}</li>
                           <span
                        class="mr-5 sub-tree-action"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <img
                          src="/assets/image/action.svg"
                          class="mr-2"
                          alt=""
                          width="20"
                          height="23"
                        />
                        {{$t("actions")}}
                      </span>
                      <div
                        class="dropdown-menu pr-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <ul class="ag-list-shared">
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneElective")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("cloneSubstitute")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("relocate")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/edit.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("edit")}}</a>
                          </div>
                          <div class="d-flex flex-row">
                            <img
                              src="/assets/icons/delete.svg"
                              alt=""
                              width="18"
                              height="20"
                              class="mr-1"
                            />
                            <a href="#">{{$t("remove")}}</a>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </ul>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div
          id="buildingblocks"
          class="fade in active show"
          v-if="sharedTab === 'buildingblocks'"
        >
          <div class="body">
            <div class="building-blocks">
              <ul class="ag-tree-list">
                <li class="list-header">
                  <a
                    class="item"
                    data-toggle="collapse"
                    data-target="#building-blocks"
                    href="#"
                  >
                    {{$t("endpointTypes")}}
                  </a>
                </li>
                <div id="building-blocks" class="collapse show">
                  <h4>{{$t("endpointTypes")}}</h4>
                  <ul class="sub-tree">
                    <li>{{$t("standardServer")}}</li>
                    <li>{{$t("RDSServer")}}</li>
                    <li>{{$t("exchange")}}</li>
                    <li>{{$t("sqlServer")}}</li>
                    <li>{{$t("activeDirectory")}}</li>
                    <li>{{$t("webServer")}}</li>
                  </ul>
                  <h4>{{$t("windowsWorkstation")}}</h4>
                  <ul class="sub-tree mb-5">
                    <li>{{$t("standardWorkstation")}}</li>
                    <li>{{$t("NP-VDI")}}</li>
                    <li>{{$t("IOT")}}</li>
                  </ul>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "SharedTopology",
  data() {
    return {
      sharedTab: "electives",
    };
  },
  methods: {
    changeSharedTab(item) {
      this.sharedTab = item;
    },
  },
};
</script>



<style lang="scss" scoped>
.ag-electives {
  border-top: 3px solid #d2d6de;
  background: #f8f8f8;
  width: 100%;
  .navigation {
    padding-right: 0px;
    display: flex;
    justify-content: center;
    align-items: center;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font: normal normal normal 15px/23px Open Sans;
      letter-spacing: 0px;
      color: #576271;
      background: #fff;
      border-bottom: 2px solid #7294a8;

      .header-tab-item {
        width: 50%;
        // padding: 12px 32px;
        line-height: 50px;
        color: #576271;
        text-align: center;
        &.selected {
          font: normal normal bold 15px/23px Open Sans;
          letter-spacing: 0px;
          line-height: 50px;
          color: #ffffff;
          background: #7294a8 0% 0% no-repeat padding-box;
        }
      }
    }

    .body {
      .endpoint-types {
        background: #42c2cc15 0% 0% no-repeat padding-box;
      }

      .appgroups {
        background: #ffc56215 0% 0% no-repeat padding-box;
      }

      .general {
        background: #bf310015 0% 0% no-repeat padding-box;
      }

      .building-blocks {
        background: #42cc9715 0% 0% no-repeat padding-box;
      }
    }
  }

  .main-content {
    padding-left: 0px;
    padding-right: 0px;

    background: #f8f8f8 0% 0% no-repeat padding-box;

    .appgroup-header {
      background: #faedd4 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      padding: 12px;
      box-shadow: 0px 3px 6px #00000029;

      h1 {
        text-align: left;
        font: normal normal 600 31px/42px Open Sans;
        letter-spacing: 0px;
        color: #b7c6cd;

        strong {
          font: normal normal 600 31px/42px Open Sans;
          letter-spacing: 0px;
          color: #7294a8;
        }
      }
    }

    .inner {
      padding: 12px;

      .inner-top {
        margin-bottom: 24px;
        display: flex;
        align-items: center;
      }

      .tab {
        display: flex;
        align-items: center;
        border-bottom: 2px solid #d9d9d9;
        margin: 0px;
        padding: 0px;

        li {
          display: flex;
          align-items: center;
          margin-right: 32px;

          &.right {
            align-items: flex-end;
            float: right;
            margin-left: auto;
            a {
              flex-direction: row;
              align-items: center;
              font-size: 14px;

              i {
                margin-right: 6px;
                margin-top: 3px;
              }
            }
          }

          &.selected {
            a {
              text-align: center;
              font: normal normal bold 18px/24px Open Sans;
              letter-spacing: 0px;
              color: #4c8dbb;
              padding-bottom: 8px;
              border-bottom: 4px solid #1878af;
              margin-bottom: -2px;
            }
          }

          a {
            text-align: center;
            font: normal normal normal 18px/24px Open Sans;
            letter-spacing: 0px;
            color: #4c8dbb;
            display: flex;
            flex-direction: column;
            align-items: center;

            &:hover {
              text-decoration: none;
            }

            i {
              margin-bottom: 8px;
            }
          }

          a.add-new {
            display: flex;
            flex-direction: row;
            font-size: 14px;
          }
        }
      }

      .body {
        margin-top: 40px;
      }
    }
  }

  .modal-title-ag {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) var(--unnamed-font-size-18) /
      var(--unnamed-line-spacing-24) var(--unnamed-font-family-open-sans);
    color: #4c8dbb;
    font-size: 20px !important;
    cursor: pointer;
  }

  .modal-title-ag-underline {
    border-bottom: 3px solid #4c8dbb;
    font-weight: 600 !important;
    font-size: 20px !important;
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) var(--unnamed-font-size-18) /
      var(--unnamed-line-spacing-24) var(--unnamed-font-family-open-sans);
  }

  .shared-tab-title {
    border-bottom: 3px solid #d2d6de;
    display: flex;
    flex-direction: row;
  }

  .shared-tab-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-right: 80px;
    margin-left: 40px;
  }
  .shared-header {
    padding-top: 10px;
  }
  .sub-tree-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .sub-tree-action {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-normal) var(--unnamed-font-size-13) / 21px
      var(--unnamed-font-family-open-sans);
    color: #4c8dbb !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .ag-tree-category {
    color: #4c8dbb !important;
    font-size: 14px !important;
    margin-right: 200px;
    cursor: pointer;
  }

  .ag-tree-node {
    color: #4c8dbb !important;
    font-size: 14px !important;
    margin-right: 230px;
    margin-top: 5px;
    cursor: pointer;
  }

  .add-node-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .list-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>

<style>
.modal-title-server {
  color: #b7c6cd;
  margin-left: 42px;
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600)
    31px/42px var(--unnamed-font-family-open-sans);
}

.modal-title-global {
  font: normal normal 600 31px/42px Open Sans;
  color: #5e5e5e;
  font-size: 25px;
}
.modal-title-category {
  font: normal normal 600 31px/42px Open Sans;
  color: #5e5e5e;
}
.model-content-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ag-modal-footer {
  display: flex;
  justify-content: space-between;
}
.ag-button-footer-white {
  width: 145px;
  height: 40px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000033;
  border: 2px solid #bfbfbf;
  border-radius: 7px;
  color: #939393;
}
.ag-button-footer {
  width: 145px;
  height: 40px;
  background: var(---164b6c-second-blue) 0% 0% no-repeat padding-box;
  background: #164b6c 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000033;
  color: #fff;
}
.ag-list-shared {
  display: flex;
  flex-direction: column;
}
</style>
